import React, { useState } from "react";
import { Button, Form, Input, Modal, Popconfirm, Select } from "antd";

import { fieldValidity } from "../../eventsmanagement/eventsratification/custom/eventEnum";
import api from "../../../services/finYearService";
import { recordError } from "../../../utils/logService";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const AddFinYear = ({ show, onShow, setHasUpdated }) => {
  const [isCurrentFinYear, setIsCurrentFinYear] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [feedBack, setFeedBack] = useState(true);
  const [ValidStatus, setValidStatus] = useState(fieldValidity.SUCCESS);
  const [ValidNotesStatus, setValidNotesStatus] = useState(
    fieldValidity.SUCCESS
  );
  const [ValidityMsg, setValidityMsg] = useState("");

  let msg = "";
  const currentFinYearLabel = `${isCurrentFinYear ? "Yes!" : "No!"}`;

  const [form] = Form.useForm();
  const { Option } = Select;
  const entity = "Financial Year";
  const formName = "AddFinancialYear";

  const onSubmit = async (values) => {
    try {
      const response = await api.addFinYear(values);

      if (response && (response.status == 201 || response.status == 200)) {
        msg = util.parseMessage(Messages.ADD_SUCCESS, entity);
        openNotification(entity, msg, Notify.SUCCESS);
        onShow(false);
        setHasUpdated(true);
      } else {
        msg = util.parseMessage(Messages.ADD_FAILURE, entity);
        openNotification(entity, msg, Notify.ERROR);
      }
    } catch (error) {
      if (error && error.response.status == 409) {
        msg = util.parseMessage(Messages.CONFLICT, entity);
        openNotification(entity, msg, Notify.ERROR);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      openNotification(entity, msg, Notify.ERROR);
      recordError(error);
    }
  };

  const Confirm = () => {
    form.resetFields();
    onShow(false);
    setDisabled(true);
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    form.setFieldsValue({ [name]: value });
    const isValid = util.isFinYearValid(value);
    if (!isValid.results) {
      setValidityMsg(isValid.message);
      setValidStatus(fieldValidity.ERROR);
      form.setFieldsValue({ startDate: "" });
      form.setFieldsValue({ endDate: "" });
      return;
    }

    setFeedBack(false);
    setValidityMsg("");
    setValidStatus(fieldValidity.SUCCESS);
    form.setFieldsValue({ startDate: isValid.startFinYear });
    form.setFieldsValue({ endDate: isValid.endFinYear });
  };

  const handleCancel = () => {
    if (
      form.getFieldValue("value") ||
      form.getFieldValue("active") ||
      form.getFieldValue("startDate") ||
      form.getFieldValue("endDate")
    ) {
      setDisabled(false);
    } else {
      form.resetFields();
      onShow(false);
      setDisabled(true);
      setFeedBack(false);
    }
  };

  return (
    <>
      <Modal
        forceRender
        title="Add New Financial Year"
        open={show}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={500}
        footer={[
          <div className="modal-footer-buttons">
            <Button
              key="2"
              type="primary"
              htmlType="submit"
              onSubmit={onSubmit}
              form={formName}
            >
              Save
            </Button>
            <Popconfirm
              key="1"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={onSubmit}
        >
          <Form.Item
            name="value"
            label="Financial Year"
            validateStatus={ValidStatus}
            help={ValidityMsg}
            rules={[
              {
                required: true,
                message: ValidityMsg,
              },
            ]}
          >
            <Input name="value" onBlur={onNameBlur} maxLength={7} />
          </Form.Item>

          <Form.Item name="startDate" label="Start Date">
            <Input name="startDate" disabled={true} />
          </Form.Item>
          <Form.Item name="endDate" label="End Date">
            <Input name="endDate" disabled={true} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddFinYear;
